<template>
  <v-app>
    <navigation-menu />
    <v-main>
      <v-container fluid>
        <router-view
          @snackbarEvent="snackbar = $event"
          @loadingEvent="loading = $event"
          :key="$route.fullPath"
        />
        <v-card
          v-if="displayBackButton"
          class="my-4 mx-auto"
          max-width="1200"
          tile
        >
          <v-btn @click="goBack" block>ZURÜCK</v-btn>
        </v-card>
      </v-container>
    </v-main>
    <v-footer padless>
      <v-card flat tile width="100%" class="text-center">
        <v-card-text class="text-caption">
          <span class="px-4"
            ><a href="/static/Datenschutzerklaerung.pdf" target="_blank"
              >Datenschutz</a
            ></span
          >|
          <span class="px-4">
            <a href="/static/Allgemeine_Nutzungsbedingungen.pdf" target="_blank"
              >ANB</a
            > </span
          >|
          <span class="px-4"
            ><a href="/static/Impressum.pdf" target="_blank">Impressum</a>
            <span class="pl-1 transpareny">{{ appVersion }}</span>
          </span>
        </v-card-text>
      </v-card>
    </v-footer>
    <!--   snackbar-status-notifizierung -->
    <v-snackbar
      id="idsnackbar"
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      bottom
      right
      multi-line
    >
      <span v-html="snackbar.text"></span>
      <v-btn class="ml-2" outlined @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
    <!--   snackbar-status-notifizierung -->
    <!--   loading Indikator abschnitt -->
    <v-dialog v-model="loading.show" persistent max-width="400" id="idloading">
      <v-card>
        <v-container style="height: 200px">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              {{ loading.text }}
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="6"
              >
              </v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!--   loading Indikator abschnitt -->
  </v-app>
</template>

<style>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
.transpareny {
  color: transparent;
  font-size: 6px;
}
</style>

<script>
import NavigationMenu from "./components/NavigationMenu.vue";
import { version } from "../package";

export default {
  components: { NavigationMenu },
  name: "App",

  data: () => ({
    //
    appVersion: version,
    loading: {
      text: "",
      show: false,
    },

    snackbar: {
      text: "",
      color: "red",
      timeout: 10000,
      show: false,
    },
  }),
  methods: {
    goBack() {
      window.history.back();
    },
  },
  computed: {
    displayBackButton: function () {
      var hideBackButtonOnRoutes = [
        "Login",
        "Registrierung",
        "Passwort-Reset anfordern",
        "Passwort zurücksetzen",
        "VertragsObjekte",
        "eMail ändern prüfen",
        "Übergabe",
      ]; //Route Namen sind definiert in /router/index.js
      return hideBackButtonOnRoutes.indexOf(this.$route.name) > -1
        ? false
        : true;
    },
  },
  mounted() {
    console.info("App version " + this.appVersion);
  },
};
</script>
